module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-a086794d.png";